export const EXT_NCBI_GENE_LINK = 'https://www.ncbi.nlm.nih.gov/gene/';
export const EXT_UNIPROT_LINK = 'https://www.uniprot.org/uniprot/';
export const EXT_ENSEMBL_LINK = 'https://www.ensembl.org/Homo_sapiens/Gene/Summary?g=';

export const onHeaderClick = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

export const DISEASE_VOCABULARY_LINKS: Record<string, string> = {
  ICD10: 'https://icd.codes/icd10cm/',
  MSH: 'https://meshb.nlm.nih.gov/record/ui?ui=',
  HPO: 'https://hpo.jax.org/app/browse/term/',
  NCI: 'https://ncit.nci.nih.gov/ncitbrowser/ConceptReport.jsp?dictionary=NCI_Thesaurus&ns=ncit&code=',
  OMIM: 'https://www.omim.org/entry/',
  ICD9CM: 'https://icd.codes/icd9cm/',
  DO: 'https://disease-ontology.org/term/DOID:',
  ORDO: 'https://www.orpha.net/en/disease/detail/',
  MONDO: 'https://www.ebi.ac.uk/ols/ontologies/mondo/terms?iri=http://purl.obolibrary.org/obo/MONDO_',
  EFO: 'https://www.ebi.ac.uk/ols/ontologies/efo/terms?short_form=EFO_',
};